// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  color: var(--tj-primary-gray-800);
}

.invoice-list {
  width: 100%;
  max-width: 1680px;
  margin: 0 auto;
  padding: 1.75rem 2rem 3rem;
}

.list-heading, .heading-actions, .filter-toolbar {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.list-heading {
  justify-content: space-between;
  margin-bottom: 1.5rem;
}
.list-heading h1 {
  font-size: 1.5rem;
  margin: 0 0 0.4rem;
}
.list-heading p {
  margin: 0;
  color: var(--tj-primary-gray-500);
}

.heading-actions {
  flex-wrap: wrap;
  justify-content: flex-end;
}

button, a {
  -webkit-tap-highlight-color: transparent;
}

button:focus-visible, a:focus-visible, input:focus-visible, select:focus-visible {
  outline: 2px solid var(--tj-primary-500);
  outline-offset: 3px;
}

.text-button {
  border: 0;
  background: transparent;
  color: var(--tj-primary-600);
  cursor: pointer;
  padding: 0.5rem;
  font: inherit;
  font-weight: 600;
}

button:disabled {
  cursor: default;
  opacity: 0.6;
}

.overview {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}
.overview button {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  padding: 1rem;
  text-align: left;
  border: 1px solid var(--tj-primary-gray-200);
  border-radius: 0.65rem;
  background: var(--p-surface-0);
  font: inherit;
  color: inherit;
  cursor: pointer;
  min-width: 0;
}
.overview span {
  font-size: 0.85rem;
  font-weight: 600;
}
.overview strong {
  font-size: 1.65rem;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
}
.overview small {
  color: var(--tj-primary-gray-500);
}
.overview button:hover {
  border-color: var(--tj-primary-300);
}
.overview button.selected {
  border-color: var(--tj-primary-500);
  box-shadow: inset 0 0 0 1px var(--tj-primary-500);
}
.overview .needs-attention strong {
  color: var(--p-orange-700);
}
.overview .has-incidents strong {
  color: var(--p-red-700);
}

.list-panel {
  background: var(--p-surface-0);
  border: 1px solid var(--tj-primary-gray-200);
  border-radius: 0.7rem;
  overflow: hidden;
}

.filter-toolbar {
  flex-wrap: wrap;
  padding: 1rem;
  border-bottom: 1px solid var(--tj-primary-gray-200);
  align-items: flex-end;
}

.search-field, .status-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.search-field label, .status-field label {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--tj-primary-gray-600);
}

.search-field {
  flex: 1;
  min-width: 13rem;
  max-width: 28rem;
}

.search-input {
  position: relative;
}
.search-input i {
  position: absolute;
  top: 50%;
  left: 0.8rem;
  transform: translateY(-50%);
  color: var(--tj-primary-gray-500);
}
.search-input input {
  width: 100%;
  padding-left: 2.3rem;
}

.status-field select {
  min-width: 13rem;
  border: 1px solid var(--tj-primary-gray-300);
  border-radius: 0.4rem;
  min-height: 2.65rem;
  padding: 0.5rem 0.7rem;
  background: var(--p-surface-0);
  color: inherit;
  font: inherit;
}

.result-count {
  margin-left: auto;
  font-size: 0.82rem;
  color: var(--tj-primary-gray-500);
  padding-bottom: 0.7rem;
  white-space: nowrap;
}

.list-message {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 0.8rem 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
}

.warning-message {
  background: var(--p-orange-50);
  color: var(--p-orange-700);
}

.error-message {
  background: var(--p-red-50);
  color: var(--p-red-700);
}

.cell-label {
  display: none;
}

.cell-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  min-width: 0;
}

.invoice-name {
  font-weight: 600;
  color: var(--tj-primary-600);
  text-decoration: none;
  font-size: 0.96rem;
  overflow-wrap: anywhere;
}
.invoice-name:hover {
  text-decoration: underline;
}

.secondary, .muted {
  color: var(--tj-primary-gray-500);
  font-size: 0.8rem;
}

.muted {
  color: var(--tj-primary-gray-500);
}

.description {
  color: var(--tj-primary-gray-500);
  font-size: 0.8rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  background: var(--tj-primary-gray-50);
  color: var(--tj-primary-gray-600);
  padding: 0.25rem 0.5rem;
  border-radius: 0.3rem;
  font-size: 0.75rem;
  line-height: 1.4;
  font-weight: 600;
  max-width: 100%;
}
.status-badge i {
  font-size: 0.75rem;
}

.status-badge.automatic {
  color: var(--p-blue-700);
  background: var(--p-blue-50);
}

.status-badge.warning {
  background: var(--p-orange-50);
  color: var(--p-orange-700);
}

.status-badge.success {
  background: var(--p-green-50);
  color: var(--p-green-700);
}

.status-badge.danger {
  background: var(--p-red-50);
  color: var(--p-red-700);
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}

.scope-chip {
  font-size: 0.76rem;
  padding: 0.2rem 0.5rem;
  border: 1px solid var(--tj-primary-gray-200);
  border-radius: 0.3rem;
  background: var(--tj-primary-gray-50);
  overflow-wrap: anywhere;
}

.latest-period {
  font-size: 0.83rem;
  font-variant-numeric: tabular-nums;
}

.attention-text {
  color: var(--p-orange-700);
  font-size: 0.77rem;
}

.incident-link {
  color: var(--p-red-700);
  font-weight: 600;
  font-size: 0.83rem;
  display: inline-flex;
  gap: 0.25rem;
  align-items: center;
  text-decoration: underline;
}

.open-button {
  display: inline-flex;
  justify-content: center;
  gap: 0.5rem;
  align-items: center;
  border: 1px solid var(--tj-primary-200);
  padding: 0.5rem 0.65rem;
  border-radius: 0.4rem;
  color: var(--tj-primary-600);
  font-weight: 600;
  font-size: 0.82rem;
  text-decoration: none;
  white-space: nowrap;
}
.open-button:hover {
  background: var(--tj-primary-50);
}

.delete-button {
  color: var(--tj-primary-gray-500);
  border: 0;
  background: transparent;
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 0.35rem;
}
.delete-button:hover {
  background: var(--p-red-50);
  color: var(--p-red-700);
}

.empty-state {
  padding: 2.75rem 1rem;
  text-align: center;
  color: var(--tj-primary-gray-500);
}
.empty-state > i {
  font-size: 1.5rem;
  color: var(--tj-primary-gray-400);
}
.empty-state h2 {
  color: var(--tj-primary-gray-700);
  font-size: 1.05rem;
  margin: 1rem 0 0.4rem;
}
.empty-state p {
  margin: 0 0 1rem;
}

.loading-state {
  padding: 2rem;
  text-align: center;
  color: var(--tj-primary-gray-500);
}
.loading-state i {
  margin-right: 0.5rem;
}

:host ::ng-deep .invoice-table table {
  width: 100%;
  table-layout: fixed;
}
:host ::ng-deep .invoice-table .p-datatable-thead > tr > th {
  white-space: normal;
}
:host ::ng-deep .invoice-table .p-datatable-tbody > tr > td {
  vertical-align: top;
  text-align: left;
  white-space: normal;
  overflow-wrap: anywhere;
}
:host ::ng-deep .invoice-table .p-datatable-thead > tr > th:nth-child(1) {
  width: 21%;
}
:host ::ng-deep .invoice-table .p-datatable-thead > tr > th:nth-child(2) {
  width: 17%;
}
:host ::ng-deep .invoice-table .p-datatable-thead > tr > th:nth-child(3) {
  width: 17%;
}
:host ::ng-deep .invoice-table .p-datatable-thead > tr > th:nth-child(4) {
  width: 16%;
}
:host ::ng-deep .invoice-table .p-datatable-thead > tr > th:nth-child(5) {
  width: 19%;
}
:host ::ng-deep .invoice-table .p-datatable-thead > tr > th:nth-child(6) {
  width: 10%;
}
:host ::ng-deep .invoice-table .p-datatable-tbody > tr.incident-row > td:first-child {
  box-shadow: inset 3px 0 var(--p-red-700);
}

@media (max-width: 1100px) {
  .invoice-list {
    padding: 1.25rem 1rem 2rem;
  }
  :host ::ng-deep .invoice-table .p-datatable-thead {
    display: none;
  }
  :host ::ng-deep .invoice-table .p-datatable-tbody > tr {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    border-bottom: 1px solid var(--tj-primary-gray-200);
    padding: 0.75rem;
    gap: 1rem;
  }
  :host ::ng-deep .invoice-table .p-datatable-tbody > tr > td {
    display: block;
    border: 0;
    padding: 0.35rem 0.5rem;
    width: auto;
  }
  :host ::ng-deep .invoice-table .p-datatable-tbody > tr > td:first-child {
    grid-column: 1/-1;
  }
  :host ::ng-deep .invoice-table .p-datatable-tbody > tr > td[colspan] {
    grid-column: 1/-1;
  }
  :host ::ng-deep .invoice-table .p-datatable-tbody > tr > td.actions-cell {
    grid-column: 1/-1;
    border-top: 1px solid var(--tj-primary-gray-100);
    padding-top: 0.75rem;
  }
  .cell-label {
    display: block;
    color: var(--tj-primary-gray-500);
    font-size: 0.73rem;
    font-weight: 600;
    margin-bottom: 0.45rem;
  }
}
@media (max-width: 640px) {
  .list-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .list-heading h1 {
    font-size: 1.3rem;
  }
  .overview {
    grid-template-columns: minmax(0, 1fr);
    gap: 0.5rem;
  }
  .overview button {
    padding: 0.8rem;
  }
  .filter-toolbar {
    gap: 1rem;
    padding: 1rem;
  }
  .search-field, .status-field {
    width: 100%;
    max-width: none;
    min-width: 0;
    flex: auto;
  }
  .result-count {
    padding: 0;
    margin: 0;
  }
}
@media (max-width: 400px) {
  :host ::ng-deep .invoice-table .p-datatable-tbody > tr {
    grid-template-columns: minmax(0, 1fr);
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/invoicing/invoice/invoice.component.scss"],"names":[],"mappings":"AAAA;EAAQ,cAAA;EAAgB,iCAAA;AAGxB;;AAFA;EAAgB,WAAA;EAAa,iBAAA;EAAmB,cAAA;EAAgB,0BAAA;AAShE;;AARA;EAAmD,aAAA;EAAe,mBAAA;EAAqB,SAAA;AAcvF;;AAbA;EAAgB,8BAAA;EAAgC,qBAAA;AAkBhD;AAlBuE;EAAK,iBAAA;EAAmB,kBAAA;AAsB/F;AAtBoH;EAAI,SAAA;EAAW,iCAAA;AA0BnI;;AAzBA;EAAmB,eAAA;EAAiB,yBAAA;AA8BpC;;AA7BA;EAAY,wCAAA;AAiCZ;;AAhCA;EAAmF,wCAAA;EAA0C,mBAAA;AAqC7H;;AApCA;EAAe,SAAA;EAAW,uBAAA;EAAyB,4BAAA;EAA8B,eAAA;EAAiB,eAAA;EAAgB,aAAA;EAAe,gBAAA;AA8CjI;;AA7CA;EAAkB,eAAA;EAAiB,YAAA;AAkDnC;;AAjDA;EAAY,aAAA;EAAe,gDAAA;EAAkD,SAAA;EAAW,qBAAA;AAwDxF;AAvDI;EAAS,aAAA;EAAe,sBAAA;EAAwB,uBAAA;EAAyB,YAAA;EAAa,aAAA;EAAe,gBAAA;EAAkB,4CAAA;EAA8C,sBAAA;EAAuB,8BAAA;EAAgC,aAAA;EAAe,cAAA;EAAgB,eAAA;EAAiB,YAAA;AAsEhR;AArEI;EAAO,kBAAA;EAAmB,gBAAA;AAyE9B;AAzEkD;EAAS,kBAAA;EAAoB,gBAAA;EAAkB,kCAAA;AA8EjG;AA9EuI;EAAQ,iCAAA;AAiF/I;AAhFI;EAAe,mCAAA;AAmFnB;AAnF0D;EAAkB,mCAAA;EAAqC,iDAAA;AAuFjH;AAtFI;EAA0B,0BAAA;AAyF9B;AAzF4D;EAAwB,uBAAA;AA4FpF;;AA1FA;EAAc,8BAAA;EAAgC,4CAAA;EAA8C,qBAAA;EAAsB,gBAAA;AAiGlH;;AAhGA;EAAkB,eAAA;EAAiB,aAAA;EAAe,mDAAA;EAAqD,qBAAA;AAuGvG;;AAtGA;EAA+B,aAAA;EAAe,sBAAA;EAAwB,WAAA;AA4GtE;AA5GkF;EAAQ,iBAAA;EAAkB,gBAAA;EAAkB,iCAAA;AAiH9H;;AAhHA;EAAgB,OAAA;EAAS,gBAAA;EAAkB,gBAAA;AAsH3C;;AArHA;EAAgB,kBAAA;AAyHhB;AAzHoC;EAAI,kBAAA;EAAoB,QAAA;EAAU,YAAA;EAAa,2BAAA;EAA6B,iCAAA;AAgIhH;AAhIqJ;EAAQ,WAAA;EAAa,oBAAA;AAoI1K;;AAnIA;EAAuB,gBAAA;EAAkB,4CAAA;EAA8C,qBAAA;EAAsB,mBAAA;EAAqB,sBAAA;EAAsB,8BAAA;EAAgC,cAAA;EAAgB,aAAA;AA8IxM;;AA7IA;EAAgB,iBAAA;EAAmB,kBAAA;EAAmB,iCAAA;EAAmC,sBAAA;EAAuB,mBAAA;AAqJhH;;AApJA;EAAgB,aAAA;EAAe,mBAAA;EAAqB,eAAA;EAAiB,SAAA;EAAW,oBAAA;EAAqB,qBAAA;EAAsB,mBAAA;AA8J3H;;AA7JA;EAAmB,8BAAA;EAAgC,0BAAA;AAkKnD;;AAlKiF;EAAiB,2BAAA;EAA6B,uBAAA;AAuK/H;;AAtKA;EAAc,aAAA;AA0Kd;;AAzKA;EAAgB,aAAA;EAAe,sBAAA;EAAwB,uBAAA;EAAyB,WAAA;EAAY,YAAA;AAiL5F;;AAhLA;EAAgB,gBAAA;EAAkB,4BAAA;EAA8B,qBAAA;EAAuB,kBAAA;EAAmB,uBAAA;AAwL1G;AAxLmI;EAAU,0BAAA;AA2L7I;;AA1LA;EAAqB,iCAAA;EAAmC,iBAAA;AA+LxD;;AA/L4E;EAAS,iCAAA;AAmMrF;;AAnM0H;EAAe,iCAAA;EAAmC,iBAAA;EAAkB,oBAAA;EAAsB,qBAAA;EAAuB,4BAAA;EAA8B,gBAAA;AA4MzQ;;AA3MA;EAAgB,oBAAA;EAAsB,mBAAA;EAAqB,YAAA;EAAa,qCAAA;EAAuC,iCAAA;EAAmC,uBAAA;EAAuB,qBAAA;EAAsB,kBAAA;EAAmB,gBAAA;EAAkB,gBAAA;EAAkB,eAAA;AAyNtP;AAzNuQ;EAAI,kBAAA;AA4N3Q;;AA3NA;EAA0B,wBAAA;EAA0B,4BAAA;AAgOpD;;AAhOoF;EAAwB,8BAAA;EAAgC,0BAAA;AAqO5I;;AArO0K;EAAwB,6BAAA;EAA+B,yBAAA;AA0OjO;;AA1O8P;EAAuB,2BAAA;EAA6B,uBAAA;AA+OlT;;AA9OA;EAAS,aAAA;EAAe,eAAA;EAAiB,YAAA;AAoPzC;;AApPwD;EAAc,kBAAA;EAAmB,sBAAA;EAAsB,4CAAA;EAA8C,qBAAA;EAAsB,qCAAA;EAAuC,uBAAA;AA6P1N;;AA5PA;EAAiB,kBAAA;EAAmB,kCAAA;AAiQpC;;AAhQA;EAAkB,0BAAA;EAA4B,kBAAA;AAqQ9C;;AArQmE;EAAiB,uBAAA;EAAyB,gBAAA;EAAkB,kBAAA;EAAmB,oBAAA;EAAsB,YAAA;EAAa,mBAAA;EAAqB,0BAAA;AA+Q1M;;AA9QA;EAAe,oBAAA;EAAsB,uBAAA;EAAyB,WAAA;EAAY,mBAAA;EAAqB,uCAAA;EAAyC,uBAAA;EAAuB,qBAAA;EAAsB,4BAAA;EAA8B,gBAAA;EAAkB,kBAAA;EAAmB,qBAAA;EAAuB,mBAAA;AA6R/Q;AA7RoS;EAAU,gCAAA;AAgS9S;;AA/RA;EAAiB,iCAAA;EAAmC,SAAA;EAAW,uBAAA;EAAyB,eAAA;EAAgB,eAAA;EAAiB,sBAAA;AAwSzH;AAxSgJ;EAAU,2BAAA;EAA6B,uBAAA;AA4SvL;;AA3SA;EAAe,qBAAA;EAAuB,kBAAA;EAAoB,iCAAA;AAiT1D;AAjT6F;EAAM,iBAAA;EAAmB,iCAAA;AAqTtH;AArT2J;EAAK,iCAAA;EAAmC,kBAAA;EAAoB,qBAAA;AA0TvN;AA1T+O;EAAI,gBAAA;AA6TnP;;AA5TA;EAAiB,aAAA;EAAe,kBAAA;EAAoB,iCAAA;AAkUpD;AAlUuF;EAAI,oBAAA;AAqU3F;;AAnUI;EAAQ,WAAA;EAAa,mBAAA;AAwUzB;AAvUI;EAA+B,mBAAA;AA0UnC;AAzUI;EAA+B,mBAAA;EAAqB,gBAAA;EAAkB,mBAAA;EAAqB,uBAAA;AA+U/F;AA9UmC;EAAiB,UAAA;AAiVpD;AAjVkE;EAAiB,UAAA;AAoVnF;AApViG;EAAiB,UAAA;AAuVlH;AAvVgI;EAAiB,UAAA;AA0VjJ;AA1V+J;EAAiB,UAAA;AA6VhL;AA7V8L;EAAiB,UAAA;AAgW/M;AA/VI;EAAwD,wCAAA;AAkW5D;;AAhWA;EACI;IAAgB,0BAAA;EAoWlB;EAlWM;IAAqB,aAAA;EAqW3B;EApWM;IAA0B,aAAA;IAAe,gDAAA;IAAkD,mDAAA;IAAqD,gBAAA;IAAiB,SAAA;EA2WvK;EA1WM;IAA+B,cAAA;IAAgB,SAAA;IAAW,uBAAA;IAAuB,WAAA;EAgXvF;EA/WM;IAA2C,iBAAA;EAkXjD;EAjXM;IAAwC,iBAAA;EAoX9C;EAnXM;IAA4C,iBAAA;IAAqB,gDAAA;IAAkD,oBAAA;EAwXzH;EAtXE;IAAc,cAAA;IAAgB,iCAAA;IAAmC,kBAAA;IAAmB,gBAAA;IAAkB,sBAAA;EA6XxG;AACF;AA5XA;EACI;IAAgB,uBAAA;IAAyB,sBAAA;EAgY3C;EAhYmE;IAAK,iBAAA;EAmYxE;EAlYE;IAAY,qCAAA;IAAuC,WAAA;EAsYrD;EAtYiE;IAAS,eAAA;EAyY1E;EAxYE;IAAkB,SAAA;IAAW,aAAA;EA4Y/B;EA5YgD;IAA+B,WAAA;IAAa,eAAA;IAAiB,YAAA;IAAc,UAAA;EAkZ3H;EAlZyI;IAAgB,UAAA;IAAY,SAAA;EAsZrK;AACF;AArZA;EACI;IAAyD,qCAAA;EAwZ3D;AACF;AACA,wyfAAwyf","sourcesContent":[":host { display: block; color: var(--tj-primary-gray-800); }\n.invoice-list { width: 100%; max-width: 1680px; margin: 0 auto; padding: 1.75rem 2rem 3rem; }\n.list-heading, .heading-actions, .filter-toolbar { display: flex; align-items: center; gap: 1rem; }\n.list-heading { justify-content: space-between; margin-bottom: 1.5rem; h1 { font-size: 1.5rem; margin: 0 0 .4rem; } p { margin: 0; color: var(--tj-primary-gray-500); } }\n.heading-actions { flex-wrap: wrap; justify-content: flex-end; }\nbutton, a { -webkit-tap-highlight-color: transparent; }\nbutton:focus-visible, a:focus-visible, input:focus-visible, select:focus-visible { outline: 2px solid var(--tj-primary-500); outline-offset: 3px; }\n.text-button { border: 0; background: transparent; color: var(--tj-primary-600); cursor: pointer; padding: .5rem; font: inherit; font-weight: 600; }\nbutton:disabled { cursor: default; opacity: .6; }\n.overview { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 1rem; margin-bottom: 1.5rem;\n    button { display: flex; flex-direction: column; align-items: flex-start; gap: .25rem; padding: 1rem; text-align: left; border: 1px solid var(--tj-primary-gray-200); border-radius: .65rem; background: var(--p-surface-0); font: inherit; color: inherit; cursor: pointer; min-width: 0; }\n    span { font-size: .85rem; font-weight: 600; } strong { font-size: 1.65rem; line-height: 1.2; font-variant-numeric: tabular-nums; } small { color: var(--tj-primary-gray-500); }\n    button:hover { border-color: var(--tj-primary-300); } button.selected { border-color: var(--tj-primary-500); box-shadow: inset 0 0 0 1px var(--tj-primary-500); }\n    .needs-attention strong { color: var(--p-orange-700); } .has-incidents strong { color: var(--p-red-700); }\n}\n.list-panel { background: var(--p-surface-0); border: 1px solid var(--tj-primary-gray-200); border-radius: .7rem; overflow: hidden; }\n.filter-toolbar { flex-wrap: wrap; padding: 1rem; border-bottom: 1px solid var(--tj-primary-gray-200); align-items: flex-end; }\n.search-field, .status-field { display: flex; flex-direction: column; gap: .5rem; label { font-size: .8rem; font-weight: 600; color: var(--tj-primary-gray-600); } }\n.search-field { flex: 1; min-width: 13rem; max-width: 28rem; }\n.search-input { position: relative; i { position: absolute; top: 50%; left: .8rem; transform: translateY(-50%); color: var(--tj-primary-gray-500); } input { width: 100%; padding-left: 2.3rem; } }\n.status-field select { min-width: 13rem; border: 1px solid var(--tj-primary-gray-300); border-radius: .4rem; min-height: 2.65rem; padding: .5rem .7rem; background: var(--p-surface-0); color: inherit; font: inherit; }\n.result-count { margin-left: auto; font-size: .82rem; color: var(--tj-primary-gray-500); padding-bottom: .7rem; white-space: nowrap; }\n.list-message { display: flex; align-items: center; flex-wrap: wrap; gap: 1rem; padding: .8rem 1rem; border-radius: .5rem; margin-bottom: 1rem; }\n.warning-message { background: var(--p-orange-50); color: var(--p-orange-700); } .error-message { background: var(--p-red-50); color: var(--p-red-700); }\n.cell-label { display: none; }\n.cell-content { display: flex; flex-direction: column; align-items: flex-start; gap: .5rem; min-width: 0; }\n.invoice-name { font-weight: 600; color: var(--tj-primary-600); text-decoration: none; font-size: .96rem; overflow-wrap: anywhere; &:hover { text-decoration: underline; } }\n.secondary, .muted { color: var(--tj-primary-gray-500); font-size: .8rem; } .muted { color: var(--tj-primary-gray-500); } .description { color: var(--tj-primary-gray-500); font-size: .8rem; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }\n.status-badge { display: inline-flex; align-items: center; gap: .25rem; background: var(--tj-primary-gray-50); color: var(--tj-primary-gray-600); padding: .25rem .5rem; border-radius: .3rem; font-size: .75rem; line-height: 1.4; font-weight: 600; max-width: 100%; i { font-size: .75rem; } }\n.status-badge.automatic { color: var(--p-blue-700); background: var(--p-blue-50); } .status-badge.warning { background: var(--p-orange-50); color: var(--p-orange-700); } .status-badge.success { background: var(--p-green-50); color: var(--p-green-700); } .status-badge.danger { background: var(--p-red-50); color: var(--p-red-700); }\n.chips { display: flex; flex-wrap: wrap; gap: .25rem; } .scope-chip { font-size: .76rem; padding: .2rem .5rem; border: 1px solid var(--tj-primary-gray-200); border-radius: .3rem; background: var(--tj-primary-gray-50); overflow-wrap: anywhere; }\n.latest-period { font-size: .83rem; font-variant-numeric: tabular-nums; }\n.attention-text { color: var(--p-orange-700); font-size: .77rem; } .incident-link { color: var(--p-red-700); font-weight: 600; font-size: .83rem; display: inline-flex; gap: .25rem; align-items: center; text-decoration: underline; }\n.open-button { display: inline-flex; justify-content: center; gap: .5rem; align-items: center; border: 1px solid var(--tj-primary-200); padding: .5rem .65rem; border-radius: .4rem; color: var(--tj-primary-600); font-weight: 600; font-size: .82rem; text-decoration: none; white-space: nowrap; &:hover { background: var(--tj-primary-50); } }\n.delete-button { color: var(--tj-primary-gray-500); border: 0; background: transparent; padding: .5rem; cursor: pointer; border-radius: .35rem; &:hover { background: var(--p-red-50); color: var(--p-red-700); } }\n.empty-state { padding: 2.75rem 1rem; text-align: center; color: var(--tj-primary-gray-500); > i { font-size: 1.5rem; color: var(--tj-primary-gray-400); } h2 { color: var(--tj-primary-gray-700); font-size: 1.05rem; margin: 1rem 0 .4rem; } p { margin: 0 0 1rem; } }\n.loading-state { padding: 2rem; text-align: center; color: var(--tj-primary-gray-500); i { margin-right: .5rem; } }\n:host ::ng-deep .invoice-table {\n    table { width: 100%; table-layout: fixed; }\n    .p-datatable-thead > tr > th { white-space: normal; }\n    .p-datatable-tbody > tr > td { vertical-align: top; text-align: left; white-space: normal; overflow-wrap: anywhere; }\n    .p-datatable-thead > tr > th { &:nth-child(1) { width: 21%; } &:nth-child(2) { width: 17%; } &:nth-child(3) { width: 17%; } &:nth-child(4) { width: 16%; } &:nth-child(5) { width: 19%; } &:nth-child(6) { width: 10%; } }\n    .p-datatable-tbody > tr.incident-row > td:first-child { box-shadow: inset 3px 0 var(--p-red-700); }\n}\n@media (max-width: 1100px) {\n    .invoice-list { padding: 1.25rem 1rem 2rem; }\n    :host ::ng-deep .invoice-table {\n        .p-datatable-thead { display: none; }\n        .p-datatable-tbody > tr { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); border-bottom: 1px solid var(--tj-primary-gray-200); padding: .75rem; gap: 1rem; }\n        .p-datatable-tbody > tr > td { display: block; border: 0; padding: .35rem .5rem; width: auto; }\n        .p-datatable-tbody > tr > td:first-child { grid-column: 1 / -1; }\n        .p-datatable-tbody > tr > td[colspan] { grid-column: 1 / -1; }\n        .p-datatable-tbody > tr > td.actions-cell { grid-column: 1 / -1; border-top: 1px solid var(--tj-primary-gray-100); padding-top: .75rem; }\n    }\n    .cell-label { display: block; color: var(--tj-primary-gray-500); font-size: .73rem; font-weight: 600; margin-bottom: .45rem; }\n}\n@media (max-width: 640px) {\n    .list-heading { align-items: flex-start; flex-direction: column; h1 { font-size: 1.3rem; } }\n    .overview { grid-template-columns: minmax(0, 1fr); gap: .5rem; button { padding: .8rem; } }\n    .filter-toolbar { gap: 1rem; padding: 1rem; } .search-field, .status-field { width: 100%; max-width: none; min-width: 0; flex: auto; } .result-count { padding: 0; margin: 0; }\n}\n@media (max-width: 400px) {\n    :host ::ng-deep .invoice-table .p-datatable-tbody > tr { grid-template-columns: minmax(0, 1fr); }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
